import { z } from "zod";
import { ResponsibilityStatusV1Schema } from "./responsibility-status.js";
export const ClientResponsibilityTrailItemV1Schema = z
    .object({
    schemaVersion: z.literal("client-responsibility-trail-item.v1.0"),
    itemId: z.string().min(1),
    headline: z.string().min(1),
    summary: z.string().min(1),
    responsibilityStatus: ResponsibilityStatusV1Schema,
    clientSafeSummary: z.string().min(1),
})
    .strict();
export const ClientResponsibilityTrailV1Schema = z
    .object({
    schemaVersion: z.literal("client-responsibility-trail.v1.0"),
    items: z.array(ClientResponsibilityTrailItemV1Schema),
})
    .strict();
//# sourceMappingURL=client-responsibility-trail.js.map